export enum PicoTypeEnum {
    P = 'P',
    I = 'I',
    C = 'C',
    O = 'O',
    None = 'None',
}
